import React from "react";
import { Tooltip, useDisclosure } from "@heroui/react";
import ArchiveModal from "../common/modal/ArchiveModal";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useTranslation } from "react-i18next";

import { FiArchive } from "react-icons/fi";
import { ImNext } from "react-icons/im";
import internalNoteImg from "../../icon-internal_note.png";
import { IoMdAddCircleOutline } from "react-icons/io";

export default function ActionsToolbar({
  orderId,
  status,
  internalNoteInit,
  onInternalNote,
  onModalAddProduct,
}) {
  const { t } = useTranslation();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const axiosPrivate = useAxiosPrivate();

  let currentDate = new Date();
  currentDate.setDate(currentDate.getDate() - 30); // date - 10 days
  let isoDate = currentDate.toISOString(); // Format ISO 8601
  isoDate = isoDate.substring(0, isoDate.length - 5); // Truncate to keep only date and time (without milliseconds)

  const checkNextOrder = async () => {
    try {
      const [currentOrderResponse, ordersResponse] = await Promise.all([
        axiosPrivate.get(`/orders/${orderId}`),
        axiosPrivate.get(`/orders?min_start_datetime=${isoDate}&status=pending_review&per_page=1000`),
      ]);

      const currentOrder = currentOrderResponse.data;
      let orders = ordersResponse.data.data;

      orders.sort((a, b) => {
        const aDeadline = new Date(a.process.deadline_datetime);
        const bDeadline = new Date(b.process.deadline_datetime);
        return aDeadline - bDeadline;
      });

      const currentJobID = currentOrder.process.jobID;
      const currentJobIDParent = currentOrder.process.jobID_parent;

      let selectedOrderId = null;

      if (currentJobIDParent && currentJobIDParent !== currentJobID) {
        const siblingOrders = orders.filter(
          order => order.process.jobID_parent === currentJobIDParent && order.process.jobID !== currentJobID
        );

        if (siblingOrders.length > 0) {
          const currentDeadline = new Date(currentOrder.process.deadline_datetime);
          const nextSibling = siblingOrders.find(
            order => new Date(order.process.deadline_datetime) > currentDeadline
          );

          if (nextSibling) {
            selectedOrderId = nextSibling.process.jobID;
          } else {
            selectedOrderId = siblingOrders[0].process.jobID;
          }
        }
      }

      if (!selectedOrderId) {
        if (orders.length === 0) {
          console.error("No pending orders found");
          return;
        }
        const currentOrderIndex = orders.findIndex(order => order.process.jobID === orderId);
        const nextOrderIndex = currentOrderIndex === -1 ? 0 : (currentOrderIndex + 1) % orders.length;
        selectedOrderId = orders[nextOrderIndex].process.jobID;
      }

      window.location.href = `/orders/${selectedOrderId}`;
    } catch (error) {
      console.error(t("error_fetching_orders"), error);
    }
  };

  return (
    <>
      <div className="w-8 bg-vistagreen flex flex-col items-center absolute text-white right-0 top-60 py-6 rounded-l-xl gap-5">
        <Tooltip
          showArrow={true}
          content={t("next_order")}
          placement="left"
        >
          <div>
            <ImNext className="w-5 h-5" data-cy="order__toolbarNextOrder" onClick={checkNextOrder} />
          </div>
        </Tooltip>

        {status === "pending_review" && (
          <Tooltip showArrow={true} content={t("archive")} placement="left">
            <div>
              <FiArchive className="w-5 h-5" data-cy="order__toolbarArchive" onClick={onOpen} />
            </div>
          </Tooltip>
        )}

        {!internalNoteInit && (
          <Tooltip showArrow={true} content={t("internal_note")} placement="left">
            <button
              type="button"
              className="w-6 h-6"
              onClick={onInternalNote}
              data-cy="order__toolbarInternalNote"
              aria-label={t("internal_note")}
            >
              <img src={internalNoteImg} alt={t("internal_note_icon")} />
            </button>
          </Tooltip>
        )}

        <Tooltip showArrow={true} content={t("add_product")} placement="left">
          <div>
            <IoMdAddCircleOutline className="w-6 h-6" data-cy="order__toolbarAddProduct" onClick={() => onModalAddProduct(true)} />
          </div>
        </Tooltip>
      </div>
      <ArchiveModal
        isOpen={isOpen}
        onClose={onClose}
        orderId={orderId}
        redirect="true"
      />
    </>
  );
}